/*
  IGO04 - BF Hero Offer: offer bar, "What's included" popup, partner hero events.
  Markup + config: snippets/igo04-offer.liquid (bar + popup, rendered once from
  layout/theme.liquid) and snippets/igo04-partner-hero.liquid (homepage). Spec: IGO04 dev spec v1.5.

  - A click anywhere on the offer bar opens the popup (focus trapped, Esc / overlay / X /
    CONTINUE SHOPPING close it, focus returns to the bar, page scroll locked with a fixed body so
    it holds on iOS Safari, inert scrollbar track kept with a classic scrollbar, offset restored).
  - After the offer end (config.endTs, re-checked here because pages are cached) the bar
    and the hero hide themselves and nothing fires.
  - GA4 events via gtag (send_to G-LHVQZ62JHL): igo04_offer_bar_click, igo04_popup_open,
    igo04_hero_seen (hero 50% in view, once per page view), igo04_hero_cta_click.
  The cart drawer part (gift bar + gift lines) is assets/igo04-cart-gifts.js.
*/
(function () {
  'use strict';

  if (window.IGO04_OFFER_INIT) return;
  window.IGO04_OFFER_INIT = true;

  var configEl = document.getElementById('igo04-config');
  var bar = document.querySelector('[data-igo04-open]');
  var popup = document.querySelector('[data-igo04-popup]');
  var hero = document.querySelector('[data-igo04-hero]');
  if (!configEl || !bar || !popup) return;

  var config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }

  var debug = (window.__igo04 = window.__igo04 || {});
  debug.offerVersion = '2026-11-03.1';
  debug.events = debug.events || [];

  /* ---------- Offer end (pages are cached: the gate in Liquid can lag) ---------- */

  function ended() {
    var endTs = Number(config.endTs) * 1000;
    return endTs > 0 && Date.now() > endTs;
  }

  if (ended()) {
    bar.hidden = true;
    if (hero) hero.hidden = true;
    return;
  }

  /* ---------- GA4 ---------- */

  var gaQueue = [];
  var gaTimer = null;

  function sendEvent(name, params) {
    window.gtag('event', name, params);
    debug.events.push(name);
  }

  function flushQueue() {
    if (typeof window.gtag !== 'function') return false;
    while (gaQueue.length) {
      var queued = gaQueue.shift();
      sendEvent(queued[0], queued[1]);
    }
    return true;
  }

  // gtag arrives with GTM/gtag.js (async): queue early events (hero seen on load) for up to 20 s.
  function track(name) {
    var payload = { send_to: config.gaId };
    if (typeof window.gtag === 'function') {
      sendEvent(name, payload);
      return;
    }
    gaQueue.push([name, payload]);
    if (gaTimer) return;
    var tries = 0;
    gaTimer = setInterval(function () {
      tries += 1;
      if (flushQueue() || tries >= 40) {
        clearInterval(gaTimer);
        gaTimer = null;
        gaQueue = [];
      }
    }, 500);
  }

  /* ---------- Popup ---------- */

  var dialog = popup.querySelector('[data-igo04-dialog]');
  var opener = null;
  var isOpen = false;

  function focusables() {
    return Array.prototype.filter.call(dialog.querySelectorAll('button, [href], [tabindex]:not([tabindex="-1"])'), function (el) {
      return !el.disabled && el.offsetParent !== null;
    });
  }

  function onKeydown(event) {
    if (!isOpen) return;
    if (event.key === 'Escape' || event.key === 'Esc') {
      event.preventDefault();
      closePopup();
      return;
    }
    if (event.key !== 'Tab') return;
    var items = focusables();
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    var active = document.activeElement;
    if (event.shiftKey && (active === first || active === dialog || !dialog.contains(active))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (active === last || !dialog.contains(active))) {
      event.preventDefault();
      first.focus();
    }
  }

  /* Scroll lock that holds on iOS Safari too (overflow:hidden on html/body is ignored there): the body
     is fixed at the current scroll offset while the popup is open, the offset is restored on close.
     With a classic (non-overlay) scrollbar, i.e. Windows, html keeps an inert scrollbar track
     (overflow-y: scroll) so the page doesn't shift; scrollbar-gutter alone doesn't hold it in Chrome. */
  var lockedScrollY = 0;

  function lockScroll() {
    lockedScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    if (window.innerWidth > document.documentElement.clientWidth) {
      document.documentElement.classList.add('igo04-popup-gutter');
    }
    document.body.style.top = -lockedScrollY + 'px';
    document.documentElement.classList.add('igo04-popup-open');
  }

  function unlockScroll() {
    document.documentElement.classList.remove('igo04-popup-open', 'igo04-popup-gutter');
    document.body.style.top = '';
    try {
      window.scrollTo({ top: lockedScrollY, left: 0, behavior: 'instant' });
    } catch (e) {
      window.scrollTo(0, lockedScrollY);
    }
  }

  function openPopup(from) {
    if (isOpen || ended()) return;
    isOpen = true;
    opener = from || null;

    popup.hidden = false;
    lockScroll();
    document.addEventListener('keydown', onKeydown, true);
    dialog.scrollTop = 0;
    dialog.focus();
    track('igo04_popup_open');
  }

  function closePopup() {
    if (!isOpen) return;
    isOpen = false;

    popup.hidden = true;
    unlockScroll();
    document.removeEventListener('keydown', onKeydown, true);

    if (opener && opener.isConnected && !opener.hidden) {
      /* preventScroll: focusing the bar must not undo the restored scroll offset */
      opener.focus({ preventScroll: true });
    } else if (document.activeElement && dialog.contains(document.activeElement)) {
      document.activeElement.blur();
    }
    opener = null;
  }

  /* ---------- Hero ---------- */

  function watchHero() {
    if (!hero || !('IntersectionObserver' in window)) return;
    var seen = false;
    var observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!seen && entries[i].isIntersecting && entries[i].intersectionRatio >= 0.5 && !hero.hidden) {
            seen = true;
            observer.disconnect();
            track('igo04_hero_seen');
            return;
          }
        }
      },
      { threshold: [0.5] }
    );
    observer.observe(hero);
  }

  /* ---------- Wire up ---------- */

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var openEl = target.closest('[data-igo04-open]');
    if (openEl) {
      event.preventDefault();
      track('igo04_offer_bar_click');
      openPopup(openEl);
      return;
    }

    if (target.closest('[data-igo04-hero-cta]')) {
      track('igo04_hero_cta_click');
      return;
    }

    if (isOpen && popup.contains(target) && target.closest('[data-igo04-close]')) {
      closePopup();
    }
  });

  debug.openPopup = openPopup;
  debug.closePopup = closePopup;
  watchHero();
})();
